import * as React from "react";
import * as styles from "./QuickJournalNightLakeShips.css";

const shipClassNames = [styles.shipOne, styles.shipTwo, styles.shipThree];
const horizonShipClassNames = [styles.horizonShipOne, styles.horizonShipTwo];

export function QuickJournalNightLakeShips({
    isPaused = false,
}: {
    isPaused?: boolean;
}) {
    const animationPlayState: React.CSSProperties["animationPlayState"] =
        isPaused ? "paused" : "running";

    return (
        <div aria-hidden="true" className={styles.container}>
            <div className={styles.horizon}>
                <span className={`${styles.shoreGlow} ${styles.shoreGlowOne}`}>
                    <span
                        className={styles.shoreLight}
                        style={{ animationPlayState }}
                    />
                    <span
                        className={styles.shoreReflection}
                        style={{ animationPlayState }}
                    />
                </span>
                <span className={`${styles.shoreGlow} ${styles.shoreGlowTwo}`}>
                    <span
                        className={styles.shoreLight}
                        style={{ animationPlayState }}
                    />
                    <span
                        className={styles.shoreReflection}
                        style={{ animationPlayState }}
                    />
                </span>
                <span className={`${styles.shoreGlow} ${styles.shoreGlowThree}`}>
                    <span
                        className={styles.shoreLight}
                        style={{ animationPlayState }}
                    />
                    <span
                        className={styles.shoreReflection}
                        style={{ animationPlayState }}
                    />
                </span>
                {horizonShipClassNames.map((shipClassName) => (
                    <div
                        key={shipClassName}
                        className={`${styles.horizonShip} ${shipClassName}`}
                        style={{ animationPlayState }}
                    >
                        <div
                            className={styles.horizonShipInner}
                            style={{ animationPlayState }}
                        >
                            <div className={styles.horizonHull} />
                            <span
                                className={styles.horizonLight}
                                style={{ animationPlayState }}
                            />
                            <span className={styles.horizonReflection} />
                        </div>
                    </div>
                ))}
            </div>
            {shipClassNames.map((shipClassName, index) => (
                <div
                    key={shipClassName}
                    className={`${styles.ship} ${shipClassName}`}
                    style={{ animationPlayState }}
                >
                    <div
                        className={styles.shipInner}
                        style={{ animationPlayState }}
                    >
                        <div className={styles.hull} />
                        <div className={styles.cabin}>
                            <span
                                className={`${styles.light} ${styles.lightOne}`}
                                style={{ animationPlayState }}
                            />
                            <span
                                className={`${styles.light} ${styles.lightTwo}`}
                                style={{ animationPlayState }}
                            />
                            {index !== 1 ? (
                                <span
                                    className={`${styles.light} ${styles.lightThree}`}
                                    style={{ animationPlayState }}
                                />
                            ) : null}
                        </div>
                        <div className={styles.reflection} />
                    </div>
                </div>
            ))}
        </div>
    );
}
